<template>
    <img v-if="icon" :src="icon" class="app-icon" alt="" />
</template>

<script>
    export default {
        name: 'app-icon',
        props: {
            tools: true,
            size: {
                default: 'default',
            },
            name: {
                type: String,
            },
        },
        computed: {
            getName() {
                return this.name;
            },
            icon() {
                if (this.tools) {
                    const key = this.getName;
                    const { appIcons } = this.tools;
                    if (appIcons[key]) {
                        return appIcons[key];
                    }
                }

                return false;
            },
        },
    };
</script>

<style>
    img.app-icon {
        width: 14px;
        height: 14px;
        position:relative;
        border-radius:25%;
    }
    td img.app-icon{
        top:2px;
    }
</style>



// WEBPACK FOOTER //
// AppIcon.vue?323d66a9